import { render, staticRenderFns } from "./MemberAuthenticationComponent.vue?vue&type=template&id=10cbfb08&scoped=true"
import script from "./MemberAuthenticationComponent.vue?vue&type=script&lang=js"
export * from "./MemberAuthenticationComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10cbfb08",
  null
  
)

export default component.exports